<div class="file-grid">
  <span class="subtitle">{{ description }}</span>
  @if (fileControl.value && selectedExtension?.includes('image')) {
    <img
      [ngClass]="{ 'file-preview': !!fileControl.value }"
      [src]="'data:' + selectedExtension + ';base64,' + fileControl.value"
      [alt]="'CONTROLS.FILE.no_image' | translate">
  } @else {
    {{ selectedExtension?.includes('image')
      ? ('CONTROLS.FILE.no_image' | translate)
      : (fileControl.value ? ('CONTROLS.FILE.selected' | translate) : ('CONTROLS.FILE.not_selected' | translate)) }}
  }
  <app-button-group alignment="center">
    <button (click)="fileInput.click()" color="primary" mat-stroked-button>
      <mat-icon style="margin-right: 5px;">cloud_upload</mat-icon>
      <mat-label>{{ 'CONTROLS.FILE.choose' | translate }}</mat-label>
    </button>
    <a [disabled]="!fileControl.value"
      [href]="link"
      color="primary"
      download
      mat-icon-button>
      <mat-icon>get_app</mat-icon>
    </a>
    <button (click)="removeFile()" color="warn" mat-stroked-button>
      <mat-icon>delete_outline</mat-icon>
      <mat-label>{{ 'QUERY_BUILDER.delete' | translate }}</mat-label>
    </button>
    <input #fileInput
      (change)="onFileChange(fileInput)"
      [accept]="selectedExtension"
      hidden
      type="file">
  </app-button-group>
</div>
